import { render, staticRenderFns } from "./MediaEditor.vue?vue&type=template&id=21485cd6&"
import script from "./MediaEditor.vue?vue&type=script&lang=js&"
export * from "./MediaEditor.vue?vue&type=script&lang=js&"
import style0 from "./MediaEditor.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/media/thed/vol_40/Laravel/bmat/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('21485cd6')) {
      api.createRecord('21485cd6', component.options)
    } else {
      api.reload('21485cd6', component.options)
    }
    module.hot.accept("./MediaEditor.vue?vue&type=template&id=21485cd6&", function () {
      api.rerender('21485cd6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/components/MediaEditor.vue"
export default component.exports